import { render, staticRenderFns } from "./LimitDetail.vue?vue&type=template&id=fd5fdc22&scoped=true&"
import script from "./LimitDetail.vue?vue&type=script&lang=js&"
export * from "./LimitDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5fdc22",
  null
  
)

export default component.exports